import { defineStore } from "pinia"

import {
  stateCartProducts,
  gettersCartProducts,
  actionsCartProducts,
  persistOptionsCartProducts,
} from "@academy/components"

export const useCartProducts = defineStore("cart-products", {
  state: () => stateCartProducts,
  getters: gettersCartProducts,
  actions: actionsCartProducts,
  ...persistOptionsCartProducts,
})
